import Vue from 'vue';
import Vuex from 'vuex';

import { AuthStore, NoticeStore, pendoPlugin } from '@kasasa/fbase-components/lib';
import Location, { locationFactory } from '@/services/Location';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
		location: locationFactory()
  },
  mutations: {
		SET_LOCATION(state, location) {
			state.location = location;
		},
  },
  actions: {
		setNewLocation(context, fkClient) {
			const location = locationFactory();
			location.fkClient = fkClient;
			context.commit('SET_LOCATION', location);
		},
		setLocation(context, location: Location) {
			context.commit('SET_LOCATION', location);
		},
  },
  modules: {
		auth: AuthStore,
		notices: NoticeStore
	},
	plugins: [pendoPlugin]
});
